import React, { useState,  useEffect } from 'react';
import login_unilever_2 from "../../assets/images/login-unilever-2.svg";
import email_icon from "../../assets/images/email-icon.svg";
import AuthMiddleware from "../../store/middleware/authMiddleware";
import Login_bg_1 from "../../assets/images/login-bg-1.png";
import Button from "@material-ui/core/Button";
import { connect } from "react-redux";
import CustomToast from "../../util-functions/customToast.jsx";
import './style.scss'

function VerifyEmail(props) {

    // const [OTPcode, setOTP] = useState({ ind1: '', ind2: '', ind3: '', ind4: '', ind5: '', ind6: '', ind7: '', ind8: '', })
    // const [OPT_1, setOPT_1] = useState('')
    // const [OPT_2, setOPT_2] = useState('')
    // const [OPT_3, setOPT_3] = useState('')
    // const [OPT_4, setOPT_4] = useState('')
    // const [OPT_5, setOPT_5] = useState('')
    // const [OPT_6, setOPT_6] = useState('')
    // const [OPT_7, setOPT_7] = useState('')
    // const [OPT_8, setOPT_8] = useState('')
    const [OTPCode, setOTPCode] = useState('')
    const [email, setEmail] = useState('')


    // let one = useRef();
    // let two = useRef();
    // let three = useRef();
    // let four = useRef();
    // let five = useRef();
    // let six = useRef();
    // let seven = useRef();
    // let eight = useRef();

    useEffect(() => {
        setEmail(props.history.location.state.email)
    }, [props.history.location.state.email])

    // function inputCodeHandle(key, value) {

        // if (key === "ind1") { if (OPT_1 === '') { setOPT_1(value) } if (value === '') { setOPT_1(value) } }
        // if (key === "ind2") { if (OPT_2 === '') { setOPT_2(value) } if (value === '') { setOPT_2(value) } }
        // if (key === "ind3") { if (OPT_3 === '') { setOPT_3(value) } if (value === '') { setOPT_3(value) } }
        // if (key === "ind4") { if (OPT_4 === '') { setOPT_4(value) } if (value === '') { setOPT_4(value) } }
        // if (key === "ind5") { if (OPT_5 === '') { setOPT_5(value) } if (value === '') { setOPT_5(value) } }
        // if (key === "ind6") { if (OPT_6 === '') { setOPT_6(value) } if (value === '') { setOPT_6(value) } }
        // if (key === "ind7") { if (OPT_7 === '') { setOPT_7(value) } if (value === '') { setOPT_7(value) } }
        // if (key === "ind8") { if (OPT_8 === '') { setOPT_8(value) } if (value === '') { setOPT_8(value) } }
    // }

    // function handleKeyUp(e) {

    //     if (e.which !== 8 && e.which !== 20) {

    //         switch (e.target.id) {
    //             case "input-one":
    //                 two.current.focus();
    //                 break;
    //             case "input-two":
    //                 three.current.focus();
    //                 break;
    //             case "input-three":
    //                 four.current.focus();
    //                 break;
    //             case "input-four":
    //                 five.current.focus();
    //                 break;
    //             case "input-five":
    //                 six.current.focus();
    //                 break;
    //             case "input-six":
    //                 seven.current.focus();
    //                 break;
    //             case "input-seven":
    //                 eight.current.focus();
    //                 break;
    //             default:
    //                 break;
    //         }
    //     }
    // }

    function handleVerifyUser() {
        if (!OTPCode.length === 8) {
            CustomToast("error", "OTP is empty!");
        } else {
            props.verifyUser(OTPCode, props.history);
        }
    }

    return (
        <div className="container-fluid main-verifyEmail-container">
            <div className=" main-verifyEmail">
                <div className=" verifyEmail-container-left">
                    <div className=" verifyEmail-container-left">
                        <div className="verifyEmail-bg-1">
                            <img src={Login_bg_1} alt='' />
                            <div className="verifyEmail-bg-2">
                                <img src={login_unilever_2} alt='' />
                            </div>
                        </div>
                    </div>
                </div>
                <div className=" verifyEmail-container-right">
                    <div style={{ margin: '10px', display: 'flex', flexDirection: 'column', padding: '20px' }}>
                        <div style={{ alignSelf: 'end' }}>
                            <img src={email_icon} alt='' />
                        </div>
                        <div style={{ margin: '10px', alignSelf: 'end' }}>
                            <p style={{ fontSize: '30px', marginBottom: '0px', fontFamily: 'Source Sans Pro,sans-serif', textAlign: 'left' }}>One more step. Please verify your email</p>
                        </div>
                        <div style={{ margin: '10px', marginBottom: '0px', alignSelf: 'end' }}>
                            <p style={{ fontSize: '16px' }}>Please enter the code that has been sent to you over the email <br></br><b>{email}</b> </p>
                        </div>
                        <div style={{ display: 'flex', flexDirection: 'row' }}>
                            {/* <div className="enter-code-main"><input className='enter-code-input'
                                value={OPT_1}
                                id={"input-one"}
                                onKeyUp={handleKeyUp}
                                ref={one}
                                onChange={(e) => inputCodeHandle("ind1", e.target.value)} /></div> */}
                            {/* <div className="enter-code-main"><input className='enter-code-input'
                                value={OPT_2}
                                id={"input-two"}
                                onKeyUp={handleKeyUp}
                                ref={two}
                                onChange={(e) => inputCodeHandle("ind2", e.target.value)} /></div> */}
                            {/* <div className="enter-code-main"><input className='enter-code-input'
                                value={OPT_3}
                                id={"input-three"}
                                onKeyUp={handleKeyUp}
                                ref={three}
                                onChange={(e) => inputCodeHandle("ind3", e.target.value)} /></div> */}
                            {/* <div className="enter-code-main"><input className='enter-code-input'
                                value={OPT_4}
                                id={"input-four"}
                                onKeyUp={handleKeyUp}
                                ref={four}
                                onChange={(e) => inputCodeHandle("ind4", e.target.value)} /></div> */}
                            {/* <div className="enter-code-main"><input className='enter-code-input'
                                value={OPT_5}
                                id={"input-five"}
                                onKeyUp={handleKeyUp}
                                ref={five}
                                onChange={(e) => inputCodeHandle("ind5", e.target.value)} /></div> */}
                            {/* <div className="enter-code-main"><input className='enter-code-input'
                                value={OPT_6}
                                id={"input-six"}
                                onKeyUp={handleKeyUp}
                                ref={six}
                                onChange={(e) => inputCodeHandle("ind6", e.target.value)} /></div> */}
                            {/* <div className="enter-code-main"><input className='enter-code-input'
                                value={OPT_7}
                                id={"input-seven"}
                                onKeyUp={handleKeyUp}
                                ref={seven}
                                onChange={(e) => inputCodeHandle("ind7", e.target.value)} /></div> */}
                            {/* <div className="enter-code-main">
                                <input className='enter-code-input'
                                    value={OPT_8}
                                    id={"input-eight"}
                                    onKeyUp={handleKeyUp}
                                    ref={eight}
                                    onChange={(e) => inputCodeHandle("ind8", e.target.value)} />
                            </div> */}

                            <div className="enter-code-main">
                                <input className='enter-code-input'
                                    value={OTPCode}
                                    id={"input-eight"}
                                    // onKeyUp={handleKeyUp}
                                    // ref={eight}
                                    onChange={(e) => setOTPCode(e.target.value)} />
                            </div>
                        </div>
                        <div style={{ alignSelf: 'end', margin: '10px', }}>
                            <Button
                                variant="outlined"
                                className="verify-email-btn"
                                onClick={(e) => handleVerifyUser(e)}
                                disabled={props.isLoading}
                            >
                                {props.isLoading ? "Verifying..." : "Verify"}
                            </Button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

const mapStateToProps = (state) => {
    return {
        isLoading: state.AuthReducer.isLoading,
    };
};

const mapDispatchToprops = (dispatch) => {
    return {
        verifyUser: (code, history) => {
            dispatch(AuthMiddleware.verifyUser(code, history));
        },
    };
};

export default connect(mapStateToProps, mapDispatchToprops)(VerifyEmail);
